import { getFunctions, httpsCallable } from 'firebase/functions';

export async function getProject1818DemoData(tenantId) {
  const fn = httpsCallable(getFunctions(), 'getProject1818DemoData', { timeout: 60000 });
  const result = await fn({ tenantId });
  return result?.data || null;
}
